import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { Label, ActionButton, DownloadFileLink } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import EmailDialog from './EmailDialog'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Modals from 'fw/globals/Modals'
import * as Formatting from 'fw/misc/Formatting';
import { CompanyInfoTabHelpers } from 'areas/shared/helpers';

class CompanyInfoTab extends SetupTab {

    urls() {
        return {
            get: API.Biz.url('/vobSetup/getVobInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationId: this.props.selectedId
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("ConnectToVOBEdit")
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    handleRequestAssociation = () => {
        const me = this;

        Modals.confirm("This will generate a request to VOCS Admin, to record your ownership of this company. Do you want to proceed?", function () {
            API.Biz.post('/vobSetup/requestAssociation', { requestedVobId: me.state.form.vobId }, {
                success: (r) => {
                    me.props.onSuccess(r.message);
                },
                error: (r) => {
                    me.props.onError(r.error);
                }
            });
        });
    }

    emailDialog = (action) => {
        let to = this.state.form.primaryContactEmail;
        let subject = "VOCS - Connection Request";
        let message = this.state.form.requestConnectionTemplateBody;

        this.setState({
            emailDialog: true,
            emailDialogTo: to,
            emailDialogSubject: subject,
            emailDialogMessage: message
        });
    }

    renderForm() {
        let labelClass = "label label-default";
        if (this.state.form.certificationStatus === 'Certified')
            labelClass = "label label-success";
        else if (this.state.form.certificationStatus === 'Expired')
            labelClass = "label label-danger";

        return (
            <React.Fragment>
                <EmailDialog
                    visible={this.state.emailDialog}
                    to={this.state.emailDialogTo}
                    subject={this.state.emailDialogSubject}
                    message={this.state.emailDialogMessage}
                    veteranOwnerId={this.state.form.primaryContactId}
                />
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            {this.state.form.name} &nbsp;
                            <small>
                                {this.state.form.location}&nbsp;&nbsp;<span className={labelClass}>{this.state.form.certificationStatus}</span>
                            </small> 
                        </h3>
                        <span className="pull-right" style={{textAlign:"right", marginTop: "5px" }}>
                            <ActionButton id='btnViewCertificate' onClick={() => CompanyInfoTabHelpers.downloadFile(this.state.form.certificateStorageToken, this.state.form.certificateFileName)} icon='save'>
                                View Company Certificate
                            </ActionButton>
                        </span>
                        <div style={{ marginTop: "5px" }}>
                            Doing Business As: <b>{this.state.form.dba ? this.state.form.dbaNames : " - "}</b>
                            <br />
                            Initial Cert Date: <b>{this.state.form.initialCertificationDate ? Formatting.formatDate(this.state.form.initialCertificationDate) : " - "}</b>
                        </div>
                        <br /><hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Label>Capabilities Statement:</Label>
                        <p>{this.state.form.productDescription}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Label>Professional Accreditation:</Label>
                        <p>{this.state.form.professionalAccreditation}</p>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}><p><Label>NAICS Codes:</Label> {this.state.form.naicsCodes}</p></Col>
                    <Col md={6}>
                        <Label>Capabilities Upload:</Label>&nbsp;
                        <DownloadFileLink
                            storageToken={this.state.form.capabilitiesStatementStorageToken}
                            fileName={this.state.form.capabilitiesStatementFileName}
                            buttonName={this.state.form.capabilitiesStatementFileName}
                            buttonStyle="link"
                            wrapFileNameLength={55}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}><p><Label>NAICS Description:</Label> {this.state.form.naicsDescription}</p></Col>
                    <Col md={6}>
                        <Row>
                            <Col md={12}>
                                <Label>Professional Accreditation Upload:</Label>&nbsp;
                                <DownloadFileLink
                                    storageToken={this.state.form.professionalAccreditationStorageToken}
                                    fileName={this.state.form.professionalAccreditationFileName}
                                    buttonName={this.state.form.professionalAccreditationFileName}
                                    buttonStyle="link"
                                    wrapFileNameLength={40}
                                />
                            </Col>
                        </Row>
                        {CompanyInfoTabHelpers.renderCertifications(this.state.form)}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <p><Label>Geographic Market:</Label> {this.state.form.geoMarket}</p>
                        <p><Label>Number of Full Time Employees:</Label> {this.state.form.employees}</p>
                        <p><Label>Service Disabled Veteran:</Label> {this.state.form.disabled}</p>
                    </Col>
                    <Col md={6}>
                        <p><Label>Website URL:</Label> {Formatting.externalLink(this.state.form.website)}</p>
                        <Label>Company Phone(s):</Label>
                        <br />
                        {CompanyInfoTabHelpers.renderPhones(this.state.form.vobPhones)}
                        <Label>Primary Contact Information:</Label> <br />
                        {this.state.form.primaryContact} - {this.state.form.primaryContactTitle}<br />
                        {CompanyInfoTabHelpers.renderPhones(this.state.form.veteranOwnerPhones)}
                        <br />
                        <a href={`mailto:${this.state.form.primaryContactEmail}`}>{this.state.form.primaryContactEmail}</a>
                    </Col>
                </Row>
                <Row>
                    <Button onClick={() => this.emailDialog("contact")} bsClass="btn btn-primary" className="pull-right" style={{ marginLeft: "10px", marginRight: "15px" }}>Request Connection</Button>
                    <Button onClick={() => this.handleRequestAssociation()} bsClass="btn btn-primary" className="pull-right">Record Ownership</Button>
                    <br />
                    <br />
                </Row>
            </React.Fragment >
        )
    }
}

export default CompanyInfoTab;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/connectToVOB/CompanyInfoTab.js